
















































































































































import { Divider } from "element-ui";
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import store from "../store/index";

interface SimilarDetailData {
	checkTextStr: string;
	similarList: any;
	pageHitDetailInfoList: any;
	newPageList: any;
}

export default Vue.extend({
	name: "SimilarListDetails",
	computed: mapState({
		reportType: (state: any) => store.getters.getReportType,
		checkInfo: (state: any) => store.getters.getCheckInfo,
		checkText: (state: any) => store.getters.getCheckText,
	}),
	watch: {
		checkInfo(newVal, oldVal) {
			this.initSimilarChart();
			this.initHitDetailInfoList();
		},
		checkText(newVal, oldVal) {
			this.initSimilarChart();
			this.initHitDetailInfoList();
		},
	},
	data(): SimilarDetailData {
		return {
			checkTextStr: "",
			similarList: [],
			pageHitDetailInfoList: [],
			newPageList: [],
		};
	},
	mounted() {
		if (this.checkInfo.hitDetailInfoList && this.checkText) {
			this.initSimilarChart();
			this.initHitDetailInfoList();
		}
	},
	methods: {
		// 将已标记的原文片段及相似片段
		initHitDetailInfoList() {
			if (this.checkInfo.hitDetailInfoList && this.checkText) {
				this.pageHitDetailInfoList = this.checkInfo.hitDetailInfoList;
				this.pageHitDetailInfoList.forEach((item: any, index: number) => {
					item.markSimilar = this.markSimilar(item, index);
				});

				this.initGroup();
				this.markOrigin2();
			}
		},
		initGroup() {
			this.newPageList = [{ len: 0, arr: [], left: [] }];
			let fragmentCombinee = this.checkInfo.fragmentCombine || "";
			let group = fragmentCombinee.split(/,|;|:/);

			group.forEach((it: any, ind: any) => {
				if (
					fragmentCombinee.includes(`:${it};`) ||
					fragmentCombinee.includes(`:${it}:`) ||
					fragmentCombinee.includes(`:${it},`) ||
					(ind == group.length - 1 && fragmentCombinee.includes(`:${it}`))
				) {
					this.newPageList[this.newPageList.length - 1].arr[this.newPageList[this.newPageList.length - 1].arr.length - 1].push(this.pageHitDetailInfoList[it]);
					this.newPageList[this.newPageList.length - 1].left.push(this.pageHitDetailInfoList[it]);
				} else {
					this.newPageList[this.newPageList.length - 1].arr.push([this.pageHitDetailInfoList[it]]);
					this.newPageList[this.newPageList.length - 1].left.push(this.pageHitDetailInfoList[it]);
				}
				this.newPageList[this.newPageList.length - 1].len += this.pageHitDetailInfoList[it].similarLength;
				if (
					fragmentCombinee.includes(`,${it};`) ||
					fragmentCombinee.includes(`:${it};`) ||
					fragmentCombinee.includes(`;${it};`) ||
					(ind == 0 && fragmentCombinee.substring(0, 2) === "0;")
				) {
					this.newPageList[this.newPageList.length - 1].left.sort((a: any, b: any) => {
						return a.beginPosition - b.beginPosition;
					});
					this.newPageList.push({ len: 0, arr: [], left: [] });
				}
			});
			this.newPageList[this.newPageList.length - 1].left.sort((a: any, b: any) => {
				return a.beginPosition - b.beginPosition;
			});
		},
		currentStyle(item: any) {
			const width = (item.length / this.checkInfo.reportModel.textLength) * 100 + "%";
			const left = (item.beginPosition / this.checkInfo.reportModel.textLength) * 100 + "%";
			return {
				width,
				left,
				"min-width": "1px",
				position: "absolute",
				"z-index": 99,
				"background-color": "#FF7272",
			};
		},
		// 标记charts图表优化，分片
		divideChartSection(list: any) {
			const section: any = [];
			list.forEach((item: any, index: number) => {
				if (section.length && item.beginPosition - (section[section.length - 1].length + section[section.length - 1].beginPosition) === 0) {
					section[section.length - 1].length = section[section.length - 1].length + item.length;
				} else {
					section.push({
						beginPosition: item.beginPosition,
						length: item.length,
					});
				}
			});
			return section;
		},
		// 初始化相似片段分布图
		initSimilarChart() {
			this.similarList = [];
			const problemList = this.divideChartSection(this.checkInfo.hitDetailInfoList || []);
			problemList.forEach((item: any, index: number) => {
				const width = (item.length / this.checkInfo.reportModel.textLength) * 100 + "%";
				const left = (item.beginPosition / this.checkInfo.reportModel.textLength) * 100 + "%";
				this.$set(this.similarList, index, {
					width,
					left,
					"background-color": "#ccc",
					"min-width": "1px",
				});
			});
			return this.similarList;
		},
		// 标记字的索引信息转成段落
		divideSection(list: number[]) {
			const section: any = [];
			list.forEach((item: number, index: number) => {
				if (section.length && list[index] - section[section.length - 1].beginIndex === 1) {
					section[section.length - 1].beginIndex = list[index];
					section[section.length - 1].length = section[section.length - 1].length + 1;
				} else {
					section.push({
						beginIndex: list[index],
						begin: list[index],
						length: 1,
					});
				}
			});
			// section.sort((a:any,b:any)=>{ return a.begin - b.begin;})
			return section;
		},
		markOrigin2() {
			this.newPageList.forEach((itm: any, inx: any) => {
				let firstPart = itm.left[0];
				let endPart = itm.left[itm.left.length - 1];
				let checkText = this.checkText.substring(firstPart.beginPosition, endPart.beginPosition + endPart.length) || "";
				// 按字标记
				const checkTextArry = checkText.split("");
				let hitStr = "";
				let flag = false;
				let currentEClass: any = null;
				let originalChars: any[] = [];
				itm.left.forEach((it: any, ind: any) => {
					originalChars = originalChars.concat(it.originalChars);
				});
				checkTextArry.forEach((items: any, index1: number) => {
					let isPart: any = "";
					itm.left.map((itemm: any) => {
						if (firstPart.beginPosition + index1 >= itemm.beginPosition) {
							isPart = itemm;
						}
					});
					// 根据不同的状态显示不同的颜色
					// 标注颜色
					let eClass = "red border-b-red";
					if (isPart.isSelfCited) {
						eClass = "yellow border-b-yellow";
					} else if (isPart.isReference) {
						eClass = "green border-b-green";
					} else if (isPart.isLaw) {
						eClass = "deepblue border-b-deepblue";
					}					

					if (originalChars.indexOf(firstPart.beginPosition + index1) != -1) {
						if (eClass !== currentEClass) {
							currentEClass = eClass;
							hitStr += `</span><span data-index="${index1}" class="${eClass}">${items}`;
						} else {
							hitStr += checkTextArry.length - 1 === index1 ? `${items}</span>` : items;
							checkTextArry.length - 1 === index1 ? (hitStr += "</span>") : hitStr;
						}
						flag = true;
						
					} else {
						if (flag) {
							hitStr += `</span>${items}`;
							currentEClass = null;
							flag = false;
						} else {
							hitStr += items;
						}
					}
				});
				// 截取前20个字符和后20个字符
				const frontStr = firstPart.beginPosition > 20 ? this.checkText.substr(firstPart.beginPosition - 20, 20) : "";
				const afterStr = this.checkText.substr(endPart.beginPosition + endPart.length, 20);
				hitStr = frontStr + hitStr + afterStr;
				let result = hitStr
					.replace(/\r\n/g, "<br />")
					.replace(/\r/g, "<br />")
					.replace(/\n/g, "<br />");
				itm.leftCom = result;
			});
		},
		// 标记原文片段
		markOriginal(item: any, index: number) {
			let checkText = this.checkText.substr(item.beginPosition, item.length) || "";
			// 按字标记
			const checkTextArry = checkText.split("");
			let hitStr = "";
			let flag = false;
			checkTextArry.forEach((items: any, index1: number) => {
				// 标注颜色
				let eClass = "red border-b-red";
				// 根据不同的状态显示不同的颜色
				if (item.isSelfCited) {
					eClass = "yellow border-b-yellow";
				} else if (item.isReference) {
					eClass = "green border-b-green";
				} else if (item.isLaw) {
					eClass = "deepblue border-b-deepblue";
				}

				if (item.originalChars.indexOf(item.beginPosition + index1) != -1) {
					if (flag) {
						hitStr += checkTextArry.length - 1 === index1 ? `${items}</span>` : items;
					} else {
						hitStr += `<span data-index="${index1}" class="${eClass}">${items}`;
						checkTextArry.length - 1 === index1 ? (hitStr += "</span>") : hitStr;
						flag = true;
					}
				} else {
					if (flag) {
						hitStr += `</span>${items}`;
						flag = false;
					} else {
						hitStr += items;
					}
				}
			});
			// 截取前20个字符和后20个字符
			const frontStr = item.beginPosition > 20 ? this.checkText.substr(item.beginPosition - 20, 20) : "";
			const afterStr = this.checkText.substr(item.beginPosition + item.length, 20);
			hitStr = frontStr + hitStr + afterStr;
			return hitStr
				.replace(/\r\n/g, "<br />")
				.replace(/\r/g, "<br />")
				.replace(/\n/g, "<br />");
		},
		// 标记相似片段
		markSimilar(item: any, index: number) {
			let checkText = item.hitText || "";
			if (!item.hasCopyRight) {
				return `<div style="background: #f6f5fa;height: 100%;border-radius: 5px;"></div>`;
			}
			// const section = this.divideSection(item.similarChars);
			// 按字标记
			const checkTextArry = checkText.split("");
			let hitStr = "";
			let flag = false;
			checkTextArry.forEach((items: any, index: number) => {
				if (item.similarChars.indexOf(item.hitBeginPosition + index) != -1) {
					if (flag) {
						hitStr += items;
					} else {
						hitStr += '<span class="red border-b-red">' + items;
						flag = true;
					}
				} else {
					if (flag) {
						hitStr += "</span>" + items;
						flag = false;
					} else {
						hitStr += items;
					}
				}
			});
			// let offset = 0;
			// section.forEach((items: any) => {
			//   const hitWord = checkText.substr(items.begin - item.hitBeginPosition - offset, items.length);
			//   checkTextArry.splice(items.begin - item.hitBeginPosition - offset, items.length, `<span data-index=${index} class="red border-b-red">${hitWord}</span>`);
			//   // 按字标的偏移量
			//   offset = offset + items.length - 1;
			// });
			// checkText = checkTextArry.join('');
			return hitStr
				.replace(/\r\n/g, "<br />")
				.replace(/\r/g, "<br />")
				.replace(/\n/g, "<br />");
		},
	},
});
